import { Typography } from "@mui/material";
import { format, parseISO, isValid } from "date-fns";
import { formatLabel } from "@/utils/format-label";

const formatDate = (value) => {
  if (!value) return "N/A";
  const parsed = parseISO(value);
  return isValid(parsed) ? format(parsed, "MMM d, yyyy h:mm a") : value;
};

// Read-only by design: the audit endpoint returns 403 on every write verb, so
// this table intentionally has no action column.
export const getAuditColumns = () => [
  {
    accessorKey: "createdAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>When</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.82rem", whiteSpace: "nowrap" }}>
        {formatDate(row.original.createdAt)}
      </div>
    ),
  },
  {
    accessorKey: "adminName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Admin</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.85rem" fontWeight={500}>
        {row.original.adminName ?? row.original.adminId ?? "N/A"}
      </Typography>
    ),
  },
  {
    accessorKey: "action",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Action</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.82rem" }}>{formatLabel(row.original.action) ?? "N/A"}</div>
    ),
  },
  {
    accessorKey: "reason",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Reason</div>,
    cell: ({ row }) => (
      <Typography fontSize="0.82rem" color="text.secondary">
        {row.original.reason ?? "—"}
      </Typography>
    ),
  },
];